export default __webpack_public_path__ + "static/media/wallet-background-waves.c574d576.png";